import { computed, type Ref } from 'vue'
import { useCountdown } from '@/composables/useCountdown'
import type { Extension } from '@/types/extension'

export const WRAPUP_TAG_COLOR = '#2563EB'
export const WRAPUP_TAG_BG_COLOR = '#DBEAFE'

export function useWrapupCountdown (extension: Ref<Extension>) {
    const startTimestamp = computed(() => {
        return extension.value?.lastHangupCallEpoch_UTC_CLIENT ?? 0
    })

    const duration = computed(() => {
        return extension.value?.wrapupTime ?? 0
    })

    const isActive = computed(() => {
        const ext = extension.value
        if (!ext) return false
        if (!ext.wrapupTime || ext.wrapupTime <= 0) return false
        if (!ext.lastHangupCallEpoch_UTC_CLIENT) return false

        const hasCalls = ext.calls && ext.calls.length > 0
        return !hasCalls
    })

    const { shouldShow: shouldShowWrapupTag, displayTime } = useCountdown({
        startTimestamp,
        duration,
        isActive
    })

    return {
        shouldShowWrapupTag,
        displayTime
    }
}
